import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { getLabelDisplayName, PREDEFINED_LABELS } from "@/lib/recipe-categories";
import type { RecipeBox } from "@/lib/types";
import { Filter, X } from "lucide-react";

interface LabelFilterProps {
  readonly recipeBox: RecipeBox | null;
  readonly selectedLabel: string | null;
  readonly onLabelChange: (label: string | null) => void;
}

export function CategoryFilter({ recipeBox, selectedLabel, onLabelChange }: LabelFilterProps) {
  const boxLabels = recipeBox?.labels ?? [];

  return (
    <div className="flex items-center gap-2">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm" className="gap-2">
            <Filter className="h-4 w-4" />
            {selectedLabel ? getLabelDisplayName(selectedLabel) : "Filter by Label"}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-56">
          <DropdownMenuLabel>Labels</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={() => onLabelChange(null)}
            className={selectedLabel === null ? "bg-accent" : ""}
          >
            All Recipes
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          {PREDEFINED_LABELS.length > 0 && (
            <>
              <DropdownMenuLabel className="text-xs text-muted-foreground">Predefined</DropdownMenuLabel>
              {PREDEFINED_LABELS.map((label) => (
                <DropdownMenuItem
                  key={label}
                  onClick={() => onLabelChange(label)}
                  className={selectedLabel === label ? "bg-accent" : ""}
                >
                  {getLabelDisplayName(label)}
                </DropdownMenuItem>
              ))}
            </>
          )}
          {boxLabels.length > 0 && (
            <>
              <DropdownMenuSeparator />
              <DropdownMenuLabel className="text-xs text-muted-foreground">Custom</DropdownMenuLabel>
              {boxLabels.map((label) => (
                <DropdownMenuItem
                  key={label}
                  onClick={() => onLabelChange(label)}
                  className={selectedLabel === label ? "bg-accent" : ""}
                >
                  {getLabelDisplayName(label)}
                </DropdownMenuItem>
              ))}
            </>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      {selectedLabel && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onLabelChange(null)}
          className="h-8 w-8 p-0"
          aria-label="Clear filter"
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
